import { useSearchParams } from 'react-router-dom'

import { VIDEO_HIDDEN_VALUE, VIDEO_PARAM } from '@/constants/constants'
import { useProject } from '../../project/hook'
import { useTutorialContext } from '../../tutorials/useTutorialContext'
import { FloatingVideoWindow } from './floatingVideoWindow'

interface WindowVideoProps {
  startVideo?: boolean
}

/**
 * ミッションの動画窓の表示条件。条件を満たすときだけ、digitane 動画 Widget を
 * 入れる窓（FloatingVideoWindow）を描画する。
 */
export const WindowVideo = ({ startVideo = false }: WindowVideoProps) => {
  const { canEdit, isOtherSiteMission, missionInfo } = useProject()
  // オープニングのモーダルが閉じてから Widget を初期化する。オープニングを
  // 表示しない利用者は最初から false なので、従来のタイミングで初期化される
  const { isOpeningVideoPending } = useTutorialContext()
  const [searchParams] = useSearchParams()
  // ?video=0 のとき（Aeon Fantasy からの遷移）ビデオモーダルを表示しない
  const isVideoHidden = searchParams.get(VIDEO_PARAM) === VIDEO_HIDDEN_VALUE

  if (
    !canEdit ||
    isOtherSiteMission ||
    !missionInfo ||
    isVideoHidden ||
    isOpeningVideoPending
  ) {
    return null
  }

  return <FloatingVideoWindow startVideo={startVideo} />
}
